import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const buildWaLink = (num) => {
  const digits = (num || "").replace(/[^\d]/g, "");
  return `https://wa.me/${digits}`;
};

export const WhatsAppButton = () => {
  const [num, setNum] = useState(null);

  useEffect(() => {
    let active = true;
    api
      .get("/config")
      .then((res) => {
        if (active && res.data?.whatsapp_enabled) setNum(res.data.whatsapp_number);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!num) return null; // Hidden until a valid number is configured

  return (
    <a
      href={buildWaLink(num)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with the team on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
        <path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.6 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-4.9 1 .9-4.8-.2-.4C5.5 18.3 5 16.7 5 15c0-6.1 5-11 11-11s11 4.9 11 11-4.9 10.8-11 10.8zm6.1-8c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2s-.9 1.1-1.1 1.3c-.2.2-.4.2-.7.1-1.8-.9-3-1.6-4.2-3.6-.3-.5.3-.5.9-1.6.1-.2 0-.4 0-.6s-.8-1.9-1-2.6c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 2.9s1.2 3.4 1.4 3.6c.2.2 2.5 3.8 6 5.3 2.2.9 3 1 4.1.9.7-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.4z" />
      </svg>
    </a>
  );
};
